export default "__VITE_ASSET__BNkUcSv7__"